import React, { useEffect, useState } from "react";
import AboutHeader from "../../components/aboutHeader/aboutHeader";
import DashboardFooter from "../../components/DashBoardFooter/dashboardFooter";
import SideBarNav from "../../components/sideBarNav/sideBarNav";
import UserAccountWrapper from "../../components/userAcountWrapper/userAccountWrapper";
import { auth, firestore } from "../../db/config";

export default function Referral() {
  const [refSize, setrefSize] = useState(0);
  const [totalState, settotalState] = useState("");
  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      const getQuery = firestore
        .collection("referrals")
        .where("rferralEmail", "==", user.email)
        .get();
      getQuery.then((refferedUser) => {
        const reffSize = refferedUser.size;
        setrefSize(reffSize);
        const getTotalDb = refferedUser.docs.map((data) => data.data());
        settotalState(getTotalDb);
      });
    });
  }, []);
  const getoverRallTotal = totalState
    ? totalState.reduce((single, cummulative) => {
        return single + cummulative.comission;
      }, 0)
    : "";

  return (
    <div>
      <AboutHeader />
      <div class="page_title_section dashboard_title">
        <div class="page_header">
          <div class="container">
            <div class="row">
              <div class="col-xl-9 col-lg-7 col-md-7 col-12 col-sm-7">
                <h1>Referral </h1>
              </div>
              <div class="col-xl-3 col-lg-5 col-md-5 col-12 col-sm-5">
                <div class="sub_title_section">
                  <ul class="sub_title">
                    <li>
                      {" "}
                      <a href="/"> Home </a>&nbsp; / &nbsp;{" "}
                    </li>
                    <li> Referral</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SideBarNav />
      <div class="l-main">
        <UserAccountWrapper />
        <div class="view_profile_wrapper_top float_left">
          <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12 col-12">
              <div class="sv_heading_wraper">
                <h3>REFERRAL HISTORY</h3>
              </div>
            </div>
            <div class="col-xl-12 col-md-12 col-lg-12 col-sm-12 col-12">
              <div class="view_profile_wrapper float_left">
                <ul class="profile_list referal_list">
                  <li>
                    <span class="detail_left_part">Total Referrals</span>{" "}
                    <span class="detail_right_part">{refSize}</span>
                  </li>

                  <li>
                    <span class="detail_left_part">
                      Total Referral Bonus Amount
                    </span>{" "}
                    <span class="detail_right_part">
                      ${getoverRallTotal} USD
                    </span>
                  </li>
                  {/* <li>
                    <span class="detail_left_part">Referral Link</span>{" "}
                    <span class="detail_right_part">http://demo</span>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <DashboardFooter />
      </div>
    </div>
  );
}
